module.exports = __webpack_public_path__ + "static/media/inviteBtnBg.7a0fc3e0.gif";